"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPaymentMir = function SvgPaymentMir(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 10"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.892 4.642v5.041h2.755V6.696h3.123c1.314-.01 2.43-.864 2.852-2.054h-8.73z",
    fill: "#37A72E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.892.517c.16 2.049 2.061 3.666 4.384 3.666h4.752c.035-.188.053-.382.053-.58 0-1.697-1.343-3.074-3.006-3.086h-6.183z",
    fill: "url(#payment-mir_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.366 4.162.002-.005a.17.17 0 0 1 .318.078v5.448h2.827V.517h-2.827c-.359.011-.764.273-.914.593l-2.25 4.79a.183.183 0 0 1-.026.053v.002a.189.189 0 0 1-.344-.107V.517h-2.828v9.166h2.828c.354-.02.75-.277.898-.593l2.31-4.915a.176.176 0 0 1 .006-.013zm-10.09.157L7.658 9.683H5.667L4.048 4.316a.183.183 0 0 0-.179-.151.183.183 0 0 0-.182.187v5.331H.919V.517h3.083c.51 0 1.043.4 1.192.894l1.347 4.467c.067.222.176.222.243 0L8.13 1.41c.15-.493.683-.893 1.193-.893h3.082v9.166H9.638V4.349a.183.183 0 0 0-.183-.184.183.183 0 0 0-.18.154z",
    fill: "#37A72E"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "payment-mir_svg__a",
    x1: 23.892,
    y1: 4.183,
    x2: 33.081,
    y2: 4.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C3"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPaymentMir);
var _default = exports["default"] = Memo;